import { createLogger } from '../../utils/logger';

const logger = createLogger('wipayOrderId');

/**
 * WiPay order_id max length is 13 characters.
 * @param {string} cartInstanceId
 */
export function generateWipayOrderId(cartInstanceId) {
  const timestamp = String(cartInstanceId || '').replace('cart_instance_', '');
  const shortTimestamp = timestamp.slice(-7);
  const randomChars = Math.random().toString(36).substring(2, 5).toUpperCase();
  const wipayOrderId = `PMC${shortTimestamp}${randomChars}`.substring(0, 13);
  logger.debug('[generateWipayOrderId] Generated:', wipayOrderId, 'from cart:', cartInstanceId);
  return wipayOrderId;
}

/** WiPay order_id for subscription payments. */
export function generateSubscriptionWipayOrderId() {
  const shortTimestamp = String(Date.now()).slice(-7);
  const randomChars = Math.random().toString(36).substring(2, 5).toUpperCase();
  return `SUB${shortTimestamp}${randomChars}`.substring(0, 13);
}
